export enum PartnerType {
  Commission = 'commission',
  Distribution = 'distribution',
  DealPassing = 'deal_passing',
}

const PARTNER_TYPES_BY_URL_TYPE = new Map<string, PartnerType>([
  ['c', PartnerType.Commission],
  ['commission', PartnerType.Commission],
  ['d', PartnerType.Distribution],
  ['deal_passing', PartnerType.DealPassing],
  ['distribution', PartnerType.Distribution],
  ['p', PartnerType.DealPassing],
]);

export const resolvePartnerType = (urlType: string): PartnerType | undefined => PARTNER_TYPES_BY_URL_TYPE.get(urlType);
